export default "__VITE_ASSET__BNSc_bq2__"